import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
const router = new VueRouter({
  mode: 'history',
  router: [
    {
      path: '*',
      name: '404 Not Found',
      beforeEnter: () => {
        window.location.href = '/'
      },
    },
  ],
  // routes: [
  //   {
  //     path: '/',
  //     name: 'home',

  //     component: () => import('../../index/views/Home.vue'),
  //   },
  //   {
  //     path: '/registerHelp',
  //     name: 'RegisterHelp',

  //     component: () => import('../views/RegisterHelp'),
  //   },
  //   {
  //     path: '/contact',
  //     name: 'Contact',

  //     component: () => import('../views/Contact'),
  //   },
  //   {
  //     path: '/download',
  //     name: 'Download',

  //     component: () => import('../views/Download'),
  //   },

  //   {
  //     path: '/service',
  //     name: 'Service',

  //     component: () => import('../views/Service'),
  //   },
  //   {
  //     path: '/promotion',
  //     name: 'Promotion',

  //     component: () => import('../views/Promotion'),
  //   },
  //   {
  //     path: '/recommended',
  //     name: 'Recommended',

  //     component: () => import('../views/Recommended'),
  //   },
  //   // end without auth
  //   {
  //     path: '/profile',
  //     name: 'Profile',

  //     component: () => import('../views/Profile'),
  //   },
  //   {
  //     path: '/deposit',
  //     name: 'Deposit',

  //     component: () => import('../views/Deposit'),
  //   },
  //   {
  //     path: '/withdraw',
  //     name: 'Withdraw',

  //     component: () => import('../views/Withdraw'),
  //   },
  //   {
  //     path: '/media',
  //     name: 'Media',

  //     component: () => import('../views/Media'),
  //   },
  //   {
  //     path: '/promotions',
  //     name: 'Promo',

  //     component: () => import('../views/Promo'),
  //   },
  //   {
  //     path: '/transactions',
  //     name: 'Transactions',

  //     component: () => import('../views/Transactions'),
  //   },
  //   {
  //     path: '/affiliate',
  //     name: 'Affiliate',

  //     component: () => import('../views/Affiliate'),
  //   },
  //   {
  //     path: '/history',
  //     name: 'History',

  //     component: () => import('../views/History'),
  //   },
  //   {
  //     path: '/user_cashbacks',
  //     name: 'Rolling',

  //     component: () => import('../views/Rolling'),
  //   },
  //   {
  //     path: '/rewards',
  //     name: 'Reward',

  //     component: () => import('../views/Reward'),
  //   },
  //   {
  //     path: '/play',
  //     name: 'Play',

  //     component: () => import('../views/Play'),
  //   },
  //   {
  //     path: '/account',
  //     name: 'Account',

  //     component: () => import('../views/Account'),
  //   },
  //   {
  //     path: '/change-password',
  //     name: 'ChangePassword',

  //     component: () => import('../views/ChangePassword'),
  //   },
  //   {
  //     path: '/card',
  //     name: 'Card',
  //     component: () => import('../views/Card'),
  //   },
  //   {
  //     path: '/slot',
  //     name: 'Slot',

  //     component: () => import('../views/Slot'),
  //   },
  //   {
  //     path: '/casino',
  //     name: 'Casino',

  //     component: () => import('../views/Casino'),
  //   },
  //   {
  //     path: '/game',
  //     name: 'Game',

  //     component: () => import('../views/Game'),
  //   },
  //   {
  //     path: '/spinner',
  //     name: 'Spinner',

  //     component: () => import('../views/Spinner'),
  //   },
  //   {
  //     path: 'login',
  //     name: 'Login',
  //     component: () => import('../views/Login.vue'),
  //   },
  //   {
  //     path: '/register',
  //     name: 'Signup',

  //     component: () => import('../views/Signup.vue'),
  //   },
  //   {
  //     path: '/register/:shareToken',
  //     name: 'Signup',

  //     component: () => import('../views/Signup.vue'),
  //   },
  //   {
  //     path: '/join/:shareToken',
  //     name: 'Join',
  //     component: () => import('../views/Join.vue'),
  //   },
  // ],
})

// router.beforeEach(async (to, from, next) => {
//   if (to.path === '/') {
//     next('/user/profile')
//     return
//   }
//   const requiresAuth = to.matched.some((record) => record.meta.requiresAuth)
//   if (requiresAuth) {
//     console.log('CheckSession!')
//     next()
//     return
//   }
//   next()
// })
export default router



// WEBPACK FOOTER //
// ./src/config/router.js